import { render } from "./App.vue?vue&type=template&id=2cba222c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=2cba222c&lang=scss"

import exportComponent from "/Users/bestian/Documents/GitHub/goodcode/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__